import { useEffect, useState } from 'react';
import { Stack, Table, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';
import type { ContractDto } from '@expeditor/shared';
import { contractsApi } from '../../shared/api/quotes';
import { useRolePrefix } from '../../shared/auth/useRolePrefix';

export function ContractsListPage() {
  const prefix = useRolePrefix();
  const [items, setItems] = useState<
    Array<ContractDto & { orderNumber: string; cargoName: string; clientDisplayName?: string | null }>
  >([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void contractsApi
      .list()
      .then((d) => setItems(d as typeof items))
      .catch((e) => setError(e instanceof Error ? e.message : 'Не удалось загрузить'));
  }, []);

  return (
    <Stack>
      <Title order={2}>Контракты</Title>
      {error && <Text c="red">{error}</Text>}
      <Table striped withTableBorder>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>№ договора</Table.Th>
            <Table.Th>№ поручения</Table.Th>
            <Table.Th>Груз</Table.Th>
            <Table.Th>Подписан</Table.Th>
            <Table.Th>Завершён</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {items.map((c) => (
            <Table.Tr key={c.id}>
              <Table.Td>
                <Text fw={500} c="blue" component={Link} to={`${prefix}/contracts/${c.id}`}>
                  {c.number}
                </Text>
              </Table.Td>
              <Table.Td>{c.orderNumber}</Table.Td>
              <Table.Td>{c.cargoName}</Table.Td>
              <Table.Td>{new Date(c.signedAt).toLocaleDateString('ru-RU')}</Table.Td>
              <Table.Td>
                {c.endedAt ? new Date(c.endedAt).toLocaleDateString('ru-RU') : '—'}
              </Table.Td>
            </Table.Tr>
          ))}
          {items.length === 0 && (
            <Table.Tr>
              <Table.Td colSpan={5}>
                <Text c="dimmed" ta="center" py="md">
                  Контрактов пока нет
                </Text>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
    </Stack>
  );
}
